import { colors } from "@material-ui/core";

import { ConfigureDestinationsModal } from "@/destinations/modals/ConfigureDestinationsModal.jsx";
import { DestinationConfigRow } from "../shared/ConfigPageRow";
import { IdentityMatchingRow } from "../shared/IdentityMatchingRow/IdentityMatchingRow";

const AdvertiserIDModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={["advertiserId"]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const AdvertiserIDRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const idSet = "advertiserId" in settings;

  return (
    <DestinationConfigRow
      name="Advertiser ID"
      textColor={idSet ? "" : colors.red[600]}
      labelText={idSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("advertiserId")}
    />
  );
};

const APITokenModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const settings = existingConfig.settings || {};

  return (
    <ConfigureDestinationsModal
      limitSettings={["apiToken"]}
      open={open}
      includeHeader={true}
      settings={settings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const APITokenRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const idSet = "apiToken" in settings;

  return (
    <DestinationConfigRow
      name="API Token"
      textColor={idSet ? "" : colors.red[600]}
      labelText={idSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const ADVERTISER_ID = "ADVERTISER_ID";
const API_TOKEN = "API_TOKEN";
const IDENTITY_MATCHING = "IDENTITY_MATCHING";

const Rows = {
  [ADVERTISER_ID]: AdvertiserIDRow,
  [API_TOKEN]: APITokenRow,
  [IDENTITY_MATCHING]: IdentityMatchingRow,
};

const Modals = {
  [ADVERTISER_ID]: AdvertiserIDModal,
  [API_TOKEN]: APITokenModal,
};

const RowOrder = [ADVERTISER_ID, API_TOKEN, IDENTITY_MATCHING];

const config = {
  Rows,
  RowOrder,
  Modals,
};

export default config;
